import { Fragment } from "react";
import { Link } from "react-router-dom";
import StoreItem from "../Store/StoreItem";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import classes from "../Store/StoreItem.module.css";
import { getFeaturedItems } from "../../productStore";
import { Pagination } from "swiper";
import Slide from "react-reveal/Slide";

const Featured = () => {
  const featuredItems = getFeaturedItems();
  return (
    <Fragment>
      <h1 className="title">Featured Items</h1>
      <hr />
      <main className="main">
        <Slide bottom>
          <ul id="small" className={classes.lists}>
            <Swiper
              slidesPerView={2}
              spaceBetween={30}
              pagination={{
                dynamicBullets: true,
              }}
              modules={[Pagination]}
              className="mySwiper"
            >
              {featuredItems.map((product) => (
                <SwiperSlide>
                  <StoreItem key={1} product={product} />
                </SwiperSlide>
              ))}
            </Swiper>
          </ul>
        </Slide>
        <Slide bottom>
          <ul id="large" className={classes.list}>
            {featuredItems.map((product) => (
              <StoreItem key={2} product={product} />
            ))}
          </ul>
        </Slide>
        <Link className="more" to="/store">
          See More...
        </Link>
      </main>
    </Fragment>
  );
};

export default Featured;
